import React, { useEffect } from "react";
import { Table, TableContainer } from "@mui/material";
import { useLocation } from "react-router-dom";

import { useGetRolesTable } from "../../hooks";
import { TableSkeleton } from "../../components";

import RolePermissionsTableHeader from "./RolePermissionsTableHeader";
import RolePermissionsTableBody from "./RolePermissionsTableBody";

export const RolePermissionsTable = ({ locationId }) => {
  const { isLoading, refetch } = useGetRolesTable({ locationId });
  const { search } = useLocation();

  useEffect(() => {
    refetch();
  }, [search?.toString()]);

  return isLoading ? (
    <TableSkeleton />
  ) : (
    <TableContainer sx={{ overflow: "auto", height: "100%" }}>
      <Table>
        <RolePermissionsTableHeader locationId={locationId} />
        <RolePermissionsTableBody locationId={locationId} />
      </Table>
    </TableContainer>
  );
};

export default RolePermissionsTable;
